"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KoaLayerType = void 0;
var KoaLayerType;
(function (KoaLayerType) {
    KoaLayerType["ROUTER"] = "router";
    KoaLayerType["MIDDLEWARE"] = "middleware";
})(KoaLayerType = exports.KoaLayerType || (exports.KoaLayerType = {}));
//# sourceMappingURL=types.js.map